export default {
  locale: null,
  authenticated: false,
  portal_settings: {}
};
